import { Injectable, computed, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  // Create a signal to hold the current route path
  private currentRoute = signal<string>('');

  // Create a computed signal that derives its value from the currentRoute signal
  public isTemplateEditorRoute = computed(() => this.currentRoute().includes('template-editor'));
  public isGlobalStylingRoute = computed(() => this.currentRoute().includes('global-customisation'));

  constructor(private router: Router) {
    // Subscribe to the router events
    this.router.events
      // Filter the events to only NavigationEnd events
      .pipe(filter((event) => event instanceof NavigationEnd))
      // Update the currentRoute signal whenever a navigation ends
      .subscribe((event) => {
        if (event instanceof NavigationEnd) this.currentRoute.set(event.urlAfterRedirects);
      });
  }
}
